/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscriptionalertpurchaseunavailablebillingunavailable5Inputs */



/**
* | output |
* | --- |
* | "Google Play can't take payments on this device. Make sure you're signed in to Google Play and purchases are available for your account." |
*
* @param {Subscriptionalertpurchaseunavailablebillingunavailable5Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const subscriptionalertpurchaseunavailablebillingunavailable5 = /** @type {((inputs?: Subscriptionalertpurchaseunavailablebillingunavailable5Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscriptionalertpurchaseunavailablebillingunavailable5Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Google Play can't take payments on this device. Make sure you're signed in to Google Play and purchases are available for your account.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Google Play no puede procesar pagos en este dispositivo. Comprueba que has iniciado sesión en Google Play y que las compras están disponibles en tu cuenta.")
	return /** @type {LocalizedString} */ ("Google Play не принимает оплату на этом устройстве. Проверьте, что вы вошли в аккаунт Google Play и в нём доступны покупки.")
});
export { subscriptionalertpurchaseunavailablebillingunavailable5 as "subscriptionAlertPurchaseUnavailableBillingUnavailable" }